import React from "react";

import { getCurrentPlatformTermsAndConditions } from "services";

import { saveFile, useTranslation } from "utils";

import { Anchor, Checkbox, Col, Form, Row } from "components";

export const SignupCheckbox = () => {
  const { t } = useTranslation("signinup");

  const handlePlatformTermsClick = async () => {
    const data = await getCurrentPlatformTermsAndConditions();
    saveFile(data, `${t("terms.terms")}.pdf`);
  };

  return (
    <Row align="top" className="margin-top-150 margin-bottom-150">
      <Col>
        <Form.Item
          name="terms"
          valuePropName="checked"
          rules={[
            {
              required: true,
              message: t("errors.checkboxRequired"),
              validator: (_, value) => (value ? Promise.resolve() : Promise.reject()),
            },
          ]}
        >
          <Checkbox data-testid="sign-up-checkbox" style={{ margin: "0 !important" }}>
            {t("terms.agree")} <Anchor onClick={handlePlatformTermsClick}>{t("terms.terms")}</Anchor>
          </Checkbox>
        </Form.Item>
      </Col>
    </Row>
  );
};
